import { render } from "./ImportPeople.vue?vue&type=template&id=0a132733&scoped=true"
import script from "./ImportPeople.vue?vue&type=script&lang=js"
export * from "./ImportPeople.vue?vue&type=script&lang=js"

import "./ImportPeople.vue?vue&type=style&index=0&id=0a132733&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a132733"]])

export default __exports__